import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../Enums/MagicField.enum';

const nonKeyWhiteList = ['condition', 'hstack', 'hidden'];

const loopItems = ({ items }: { items: ItemScheme[] }) => {
	let data: { [key: string]: any } = {};

	for (const item of items) {
		const { key, type, children } = item;

		if (!key && nonKeyWhiteList.indexOf(type) === -1) {
			continue;
		}

		if (key) {
			if (
				['radio_list', 'checkbox_list', 'select'].indexOf(item.type) === -1 &&
				children?.length
			) {
				if (item.type === 'multiplier') {
					data[key] = [];
				} else if (['condition', 'hstack'].indexOf(item.type) !== -1) {
					// @ts-ignore TODO: fix types, they are incompatible due to Omit <ItemScheme, "type">
					const childData = loopItems({ items: children });

					data = {
						...data,
						...childData,
					};
				} else {
					// @ts-ignore TODO: fix types, they are incompatible due to Omit <ItemScheme, "type">
					data[key] = loopItems({ items: children });
				}
			} else if (
				[
					'radio_list',
					'checkbox_list',
					'select',
					MagicField.PATIENT_SELECT,
					MagicField.DOCTOR_SELECT,
					MagicField.QUESTIONNAIRE_SELECT,
				].includes(item.type)
			) {
				data[key] = item?.value?.toString() ?? item?.defaultValue?.toString();
			} else {
				data[key] = item?.value ?? item?.defaultValue ?? null;
			}
		}
	}

	return data;
};

export const getDefaultData = ({ data }: { data: ItemScheme[] }) => {
	return loopItems({ items: data });
};
